import { jsPDF } from 'jspdf';
import QRCode from 'qrcode';
import { designRows, designTitle } from './designSummary';

const loadImage = src => new Promise((resolve, reject) => { const image = new Image(); image.onload = () => resolve(image); image.onerror = reject; image.src = src; });
async function toJpeg(blob) {
  const url = URL.createObjectURL(blob);
  try {
    const image = await loadImage(url), canvas = document.createElement('canvas'), ctx = canvas.getContext('2d');
    canvas.width = image.width; canvas.height = image.height; ctx.fillStyle = '#c3ccc7'; ctx.fillRect(0, 0, canvas.width, canvas.height); ctx.drawImage(image, 0, 0);
    return canvas.toDataURL('image/jpeg', .85);
  } finally { URL.revokeObjectURL(url); }
}

export async function buildSpecSheet({ design, product, finish, link, image }) {
  const pdf = new jsPDF({ unit: 'mm', format: 'a4' }), W = 210, M = 16;
  const [render, qr, logo] = await Promise.all([toJpeg(image), QRCode.toDataURL(link, { margin: 1, width: 320, color: { dark: '#151e1b' } }), loadImage('/branding/viewlux-colorado/logo.png').catch(() => null)]);
  pdf.setFillColor('#f3efe4'); pdf.rect(0, 0, W, 30, 'F'); pdf.setFillColor('#2f5a43'); pdf.rect(0, 30, W, 1.2, 'F');
  if (logo) { const h = 17, w = Math.min(80, h * logo.width / logo.height); pdf.addImage(logo, 'PNG', M, 6.5, w, h, undefined, 'FAST'); }
  else { pdf.setTextColor('#151e1b'); pdf.setFont('helvetica', 'bold'); pdf.setFontSize(16); pdf.text('VIEWLUX', M, 19); }
  pdf.setTextColor('#2f5a43'); pdf.setFont('helvetica', 'normal'); pdf.setFontSize(8);
  pdf.text('DESIGN SPECIFICATION', W - M, 15, { align: 'right' }); pdf.text(new Date().toLocaleDateString(), W - M, 21, { align: 'right' });
  pdf.setTextColor('#151e1b'); pdf.setFontSize(20); pdf.text(designTitle(design, product), M, 44);
  pdf.setFillColor('#c3ccc7'); pdf.rect(M, 50, W - 2 * M, 100, 'F');
  pdf.addImage(render, 'JPEG', (W - 100) / 2, 50, 100, 100);
  let y = 162;
  pdf.setFontSize(9); pdf.setTextColor('#5d6e63'); pdf.text('SPECIFICATION', M, y); y += 4;
  for (const [label, value] of designRows(design, product, finish)) {
    pdf.setDrawColor('#d8ddd6'); pdf.line(M, y, W - M, y); y += 6;
    pdf.setFontSize(9); pdf.setTextColor('#5d6e63'); pdf.text(label, M, y);
    pdf.setFontSize(10); pdf.setTextColor('#151e1b'); pdf.text(String(value), M + 42, y, { maxWidth: W - 2 * M - 42 }); y += 3;
  }
  pdf.line(M, y, W - M, y);
  const qy = 250;
  pdf.addImage(qr, 'PNG', M, qy, 30, 30);
  pdf.setFontSize(10); pdf.setTextColor('#151e1b'); pdf.text('Open this design in ViewLux Studio', M + 36, qy + 7);
  pdf.setFontSize(7.5); pdf.setTextColor('#2f5a43'); pdf.splitTextToSize(link, W - 2 * M - 36).forEach((line, i) => pdf.textWithLink(line, M + 36, qy + 12 + i * 3.4, { url: link }));
  pdf.setTextColor('#7a857d'); pdf.setFontSize(7);
  pdf.text('Visual concept for discussion only. Sizes, shapes, corners and grilles are not manufacturer-approved specifications;', M + 36, qy + 22);
  pdf.text('final dimensions, engineering and installation must be confirmed by ViewLux. Colours are screen approximations.', M + 36, qy + 26);
  return pdf;
}
